window.onresize = function () {
    var elements = document.querySelectorAll('.js-iframe-wrapper js-static-gmap-wrapper iframe');
    for (let i = 0; i < elements.length; i++) {
        elements[i].width = window.innerWidth;
    }
};